import styled, { css } from 'styled-components';
import { bordaArredondar, espacamento } from '../../styles/constants/sizes';

export const JanelaAcessibilidade = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 4px;
  padding: ${espacamento.medio}px;
  box-shadow: 0 5px 30px 0 rgb(0 0 0 / 50%);
  display: flex;
  width: 80%;
  max-width: 600px;
  flex-direction: column;

  div {
    max-height: 90vh;
  }

  ${(props) => props.contrast && css`
    background-color: #343434;

    svg {
      fill: #fff;
    }

    h4 {
      color: #fff;
    }

    span {
      background-color: #000;
      color: #fff
    }
  `};
`;

export const TituloAcessibilidade = styled.h4`
  font-size: 1.2em;
  border-bottom: 1px solid #dededd;
  padding-bottom: ${espacamento.extraPequeno}px;
  margin-top: 0;
  color: #828282;
`;

export const Acessibilidade = styled.span`
  background-color: #f2f2f2;
  border-radius: ${bordaArredondar}px;
  border: 1px solid #ddd;
  padding: ${espacamento.pequeno}px;
  white-space: pre-wrap;
  max-height: 30em;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #6eb5e6;
    border-radius: 20px;
  }
`;
